
























import Vue from 'vue'
import { LogService } from '@/api/services/logs'

export default Vue.extend({
  data() {
    return {
      columns: [
        { label: 'Date et Heure', field: 'createdAt' },
        { label: 'Information', field: 'text', searchable: true },
        { label: 'Responsable', field: 'causer.fullname', searchable: true },
        { label: 'Action', field: '_action', align: 'right' }
      ],
      logs: [] as any[],
      total: undefined as number | undefined,
      pagination: {
        page: 1,
        perPage: 10
      }
    }
  },

  async mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      const response = await LogService.findAll(this.pagination)
      this.logs = response.result
      this.total = response.count
    },

    onSeeDetails() {
      // TODO
    },

    onPrev() {
      if (this.pagination.page > 1) {
        this.pagination.page--
        this.fetchData()
      }
    },

    onNext() {
      if (
        this.total &&
        this.pagination.page * this.pagination.perPage < this.total
      ) {
        this.pagination.page++
        this.fetchData()
      }
    }
  }
})
